<template>
  <div class="grow">
    <HandoverPaymentForm v-if="booking?.currentBalance" :booking="booking" />
  </div>
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';
import HandoverPaymentForm from './HandoverPaymentForm.vue';

const route = useRoute();

const { data: booking, refetch: refetchBooking } = useBooking(route.params.id as string);

// The amounts to charge depend on the balance, so never render the form from a cached booking
// without it (seen in production as ROS-FRONTEND-ZN)
watch(
  () => !!booking.value && !booking.value.currentBalance,
  (isMissingBalance) => {
    if (isMissingBalance) void refetchBooking();
  },
  { immediate: true },
);
</script>
